(() => {
  const regularAtcForm = document.querySelector("product-form form");
  const stickyAtc = document.querySelector(".js-stciky-atc");
  const trueBuyButton = document.querySelector(".product-form .product-form__submit");
  const compareAtPriceElem = stickyAtc.querySelector(".product-price-block__compare-at-price");
  const priceElem = stickyAtc.querySelector(".product-price-block__price");
  const variantImg = document.querySelector(".js-sticky-atc__product-image");
  const variantTitle = document.querySelector(".js-sticky-atc__product-title");
  const productVariantsParent = document.querySelector(".js-product-variants-parent");
  const percentageElem = stickyAtc.querySelector(".js-product-price-block-percentage");

  const stickyBuyButton = document.querySelector(".js-stciky-atc-button");
  let klaviyoButton = null;
  const observer = new MutationObserver((mutationsList, observer) => {
    const klaviyoTrigger = document.querySelector(".klaviyo-bis-trigger");
    if (klaviyoTrigger) {
      stickyBuyButton.addEventListener("click", function () {
        if (stickyBuyButton.classList.contains("sticky-atc--disabled")) {
          klaviyoTrigger.click(); 
        } else {
          const submitEvent = new Event("submit", { cancelable: true });
          regularAtcForm.dispatchEvent(submitEvent);
        }
      });
      observer.disconnect(); 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const handleStickyAtcVisibility = () => {
    const isBelow = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top < window.innerHeight;
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && isBelow(entry.target)) {
          stickyAtc.classList.add("visible");
        } else {
          stickyAtc.classList.remove("visible");
        }
      });
    });

    if (regularAtcForm) {
      intersectionObserver.observe(regularAtcForm);
    }
  };
  const handleAddToCart = () => {
    stickyBuyButton.addEventListener("click", function (event) {
      if (klaviyoButton && getComputedStyle(klaviyoButton).display !== "none") {
        event.preventDefault();
        klaviyoButton.click();
      } else {
        const submitEvent = new Event("submit", { cancelable: true });
        regularAtcForm.dispatchEvent(submitEvent);
      }
    });
    stickyBuyButton.addEventListener("click", function (event) {
      const innerLink = stickyBuyButton.querySelector(".klaviyo-bis-trigger");
      if (innerLink && event.target === innerLink) {
        event.preventDefault();
        klaviyoButton.click();
      }
    });
  };

  const changePrice = (newPrice, newCompareAtPrice) => {
    const formatPrice = (priceInCents) => {
      return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(priceInCents / 100);
    };

    const newPercentage = Math.round(((newCompareAtPrice - newPrice) / newCompareAtPrice) * 100);

    const showCompare = newPercentage >= 5;

    priceElem.textContent = formatPrice(newPrice);

    if (compareAtPriceElem && newCompareAtPrice && newCompareAtPrice > newPrice && showCompare) {
      compareAtPriceElem.textContent = formatPrice(newCompareAtPrice);
      compareAtPriceElem.classList.remove("hidden");
      priceElem.classList.add("--discounted");
    } else {
      compareAtPriceElem.classList.add("hidden");
      priceElem.classList.remove("--discounted");
    }

    if (percentageElem && newPercentage >= 5) {
      percentageElem.textContent = newPercentage + " %";
      percentageElem.classList.remove("hidden");
    } else {
      percentageElem.classList.add("hidden");
    }
  };

  const changeVariantImg = (featuredImage) => {
    variantImg.src = featuredImage.src;
    variantImg.srcset = featuredImage.src;
  };

  const changeVariantTitle = (name) => {
    variantTitle.textContent = `${name}`;
  };

  const changeStickyButton = () => {
    setTimeout(() => {
      if (trueBuyButton.hasAttribute("disabled")) {
        stickyBuyButton.classList.add("sticky-atc--disabled");
      } else {
        stickyBuyButton.classList.remove("sticky-atc--disabled");
      }
      stickyBuyButton.querySelector("span").innerText = trueBuyButton.querySelector("span").innerText;
    }, 1500);
  };

  const updateSelectedDropdown = (variantId) => {
    const selectDropdown = document.querySelector("select[name='options[Größe]']");
    if (selectDropdown) {
      const options = selectDropdown.options;
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === variantId) {
          selectDropdown.selectedIndex = i;
          break;
        }
      }
    }
  };

  function variantSelectsCallback(event) {
    let checkedInput = event.target;
    const variantPicker = document.querySelector(".product-variant-picker-selector select");

    if (variantPicker) {
        const selectedOption = variantPicker.options[variantPicker.selectedIndex];
        if (selectedOption) {
            const selectedValue = selectedOption.value;
            const stickyTitleElem = document.querySelector(".js-sticky-atc__product-title");
            if (stickyTitleElem) {
                const existingText = stickyTitleElem.textContent.trim();
                const updatedText = existingText.match(/(\/|\s-\s)[^/-]*$/)
                ? existingText.replace(/(\/|\s-\s)[^/-]*$/, `$1${selectedValue}`)
                : `${existingText} - ${selectedValue}`;
                stickyTitleElem.textContent = updatedText;
            }
        }
    }

    if (checkedInput.checked) {
        const scriptElement = document.querySelector(`script[type="application/json"][data-resource="${checkedInput.id}"]`);
        if (scriptElement) {
            const jsonContent = scriptElement.textContent;
            const parsedData = JSON.parse(jsonContent);
            if (!parsedData) {
                return;
            }
            const { price, compare_at_price, name } = parsedData;
            changePrice(price, compare_at_price);
            changeVariantTitle(name);
            changeStickyButton();
            if (parsedData.featured_image) {
                changeVariantImg(parsedData.featured_image);
            }
        }
    }
}

  
  const monitorKlaviyoButton = () => {
    const observer = new MutationObserver(() => {
      klaviyoButton = document.querySelector(".klaviyo-bis-trigger");
      if (klaviyoButton) {
        changeStickyButton();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (productVariantsParent) {
    productVariantsParent.addEventListener("change", (event) => {
      variantSelectsCallback(event);
    });
  }

  const init = () => {
    handleStickyAtcVisibility();
    handleAddToCart();
    monitorKlaviyoButton();
    changeStickyButton();
  };

  init();
})();
